export const parseIncludes = (metadata) => {
  if (!metadata) return [];

  return Object.keys(metadata)
    .filter((key) => key.startsWith("includes_"))
    .flatMap((key) => {
      try {
        return JSON.parse(`[${metadata[key]}]`.replace(/,\s*]$/, "]"));
      } catch (error) {
        console.error(`Error parsing ${key}:`, error);
        return [];
      }
    });
};
export const parseProductDesc = (metadata) => {
  if (!metadata) return [];

  const parsedData = Object.keys(metadata)
    .filter((key) => key.startsWith("product_details_bullet_point_desc"))
    .flatMap((key) => {
      try {
        let parsed = JSON.parse(metadata[key]);
        return parsed;
      } catch (error) {
        console.error(`Error parsing ${key}:`, error);
        return [];
      }
    });

  return parsedData.flat();
};
